import React from 'react';
import background from '../../assets/hurricanes.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoStormsurge extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Storm Surge"
        paragraph="A storm surge occurs when cyclonic winds from an approaching storm push a wall of extra water onto the shore. The magnitude of a storm surge depends not only on a hurricane’s winds, but also on its speed, size, and the angle at which it approaches the coast (NASA)."
        coverbackground={background}
     />
  
  );
 }
}   

export default InfoStormsurge;